import React, { ReactElement } from 'react';
import { Event } from 'services/api';
import { OrganizationSummary } from 'services/api/models';
import { EventGridCard, EventGridCardSkeleton } from './events-browse/EventGridCard';

export interface PickedEventCardProps {
  event: Event;

  onDetails?: () => void;
  onEventClick?: () => void;

  onOrgClick?: (org: OrganizationSummary) => void;
}

const noop = (): void => undefined;

export const PickedEventCard = ({
  event,
  onDetails = noop,
  onEventClick,
  onOrgClick,
}: PickedEventCardProps): ReactElement => (
  <EventGridCard
    event={event}
    reserved={false}
    checkedIn={false}
    onCheckIn={noop}
    onDetails={onDetails}
    onEventClick={onEventClick}
    onOrgClick={onOrgClick}
  />
);

export const PickedEventCardSkeleton = (): ReactElement => (
  <EventGridCardSkeleton />
);
